import declare from "dojo/_base/declare";
import EditController from "csi/action/EditController";

const PromoteSpecialToColorSpec = declare(EditController, {
});

export = PromoteSpecialToColorSpec;